<template>
  <v-dialog v-model="value" max-width="700px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline font-weight-thin" v-if="mode === 'create'">Create New Tag</span>
        <span class="headline font-weight-thin" v-else> Edit: {{ originalLabel }}</span>
      </v-card-title>
      <v-card-text class="mt-2">
        <v-form v-model="valid" ref="form">
          <v-text-field
            :rules="labelRules"
            class="mb-2 mt-3"
            clearable
            data-cy="tagLabel"
            label="Tag Label"
            outlined
            ref="labelInput"
            required
            v-model="tag.label"
          ></v-text-field>
          <v-textarea
            auto-grow
            class="mb-2 mt-3"
            clearable
            counter="250"
            data-cy="tagDescription"
            dense
            label="Tag Description"
            maxlength="250"
            outlined
            v-model="tag.description"
          ></v-textarea>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close" data-cy="cancelButton" outlined small>Cancel</v-btn>
            <v-btn @click="save" :disabled="disableSubmit" color="primary" data-cy="saveButton" outlined small
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    disableSubmit() {
      return !this.valid;
    },
    ...mapState({
      tag: state => state.admin.tag.edit,
      serviceAreaId: state => state.session.serviceArea,
    }),
  },
  data() {
    return {
      labelRules: [name => !!name || "Label is required", () => this.labelDoesNotConflict() || "Label must be unique."],
      originalLabel: "",
      valid: false,
    };
  },
  methods: {
    checkForLabelConflict() {
      const conflict = this.tagList.find(tag => {
        const labelMatch = `${tag.label}`.trim().toUpperCase() === `${this.tag.label}`.trim().toUpperCase();
        return labelMatch && !(tag.id === this.tag.id);
      });
      return conflict ? true : false;
    },
    close() {
      this.$emit("input", false);
    },
    labelDoesNotConflict() {
      return this.checkForLabelConflict() ? false : true;
    },
    async save() {
      this.isSavingData = true;

      delete this.tag.releaseNotesUsingTag;

      const data = Object.assign(this.tag, { serviceAreaId: this.serviceAreaId });
      try {
        if (this.mode === "edit") {
          await this.updateTag(data);
        }
        if (this.mode === "create") {
          await this.createTag(data);
        }
        this.$notifySuccess();
        this.close();
        this.fetchList(this.serviceAreaId);
      } catch (e) {
        console.error(e);
        this.$notifyError(e);
      }
      this.isSavingData = false;
    },
    ...mapActions({
      createTag: "admin/tag/create",
      updateTag: "admin/tag/update",
      fetchList: "admin/tag/fetchList",
    }),
  },
  props: {
    mode: { required: true, type: String },
    tagList: { required: true, type: Array },
    value: { required: true, type: Boolean },
  },
  watch: {
    value(val) {
      if (!val) {
        return;
      }
      if (this.mode === "edit") {
        this.originalLabel = this.tag.label;
      }

      if (this.mode === "create" && this.$refs.form) {
        this.resetCreateForm();
      }
    },
  },
};
</script>
